import { GET_COUNTRY_LIST } from './ApiConstants';
import api from './ApiHandler';

export interface CategoryRequest {
  page: number;
  limit: number;
  sortDirection?: number;
  sortBy?: string;
}

export const getCountriesByPage = async (payload: CategoryRequest) => {
  return await api.get('get-country-list/provision', { params: { ...payload } });
};
